import Vue from 'vue';
import anchorFilter from '@/project/filters/anchor.filter';
Vue.use(anchorFilter);
